import { Router } from 'next/router'
import { initializeApp } from "firebase/app"
import { getAnalytics, logEvent } from "firebase/analytics"
import {isProduction} from "~/helpers/environment";

const compareBuildIds = async (url) => {
  if (typeof window !== 'undefined') {
    // const serverBuildId = (await axios.get('/build-info'))?.data.id
    // const localBuildId = getNestedProp(window, '__NEXT_DATA__.buildId')

    /* TODO: instead of reloading without user input, we should have a notification
     *       letting the user know that there's a new version.  We shouldn't be
     *       assuming that the user wants it reloaded and have to reconnect to the
     *       host and wait for the app before they can do what they wanted.
     */
   /* if (localBuildId && serverBuildId && localBuildId !== serverBuildId) {
      window.location = url
    }*/
  }
}

const firebaseConfig = {
  apiKey: 'AIzaSyCYIwk2Y-Nnm8pB69t0hmpGqlvrwqHsSM0',
  authDomain: 'gg-frontend.firebaseapp.com',
  databaseURL: 'https://gg-frontend.firebaseio.com',
  projectId: 'gg-frontend',
  storageBucket: 'gg-frontend.appspot.com',
  messagingSenderId: '993508496378',
  appId: '1:993508496378:web:552b05ee7623286ffb0a43',
  measurementId: 'G-DYFBK2M1RF'
}

export let analytics, app
if (typeof window !== 'undefined' && isProduction) {
  app = initializeApp(firebaseConfig, 'GameGlass')
  analytics = getAnalytics(app)
}

const firebaseEvent = async (url) => {
  if (typeof window !== 'undefined' && isProduction) {
    if (!analytics) return

    url = url || (location.pathname + location.search)

    const pathname = url.split('?')[0] || location.pathname
    // const search = url.split('?')[1] || location.search

    const paths = pathname.split('/').filter(_ => _)

    const event = []

    const addShard = (defaultShard = '') => {
      if (paths[1]) {
        event.push(...paths.slice(1))
      } else {
        event.push(defaultShard)
      }
    }

    switch (paths[0]) {
    case 'elitedangerous': {
      event.push('ED')
      addShard('flight')
      break
    }

    case 'starcitizen': {
      event.push('SC')
      addShard('flight')
      break
    }

    default: {
      event.push(paths[0])
      break
    }
    }

    logEvent(analytics, event.join(' '))
  }
}

const handleRouteComplete = () => {
  window.segment?.page()
}

const EVENTS = {
  routeChangeStart: {
    name: 'routeChangeStart',
    callbacks: [compareBuildIds]
  },
  routeChangeComplete: {
    name: 'routeChangeComplete',
    callbacks: [firebaseEvent, handleRouteComplete]
  }
}

const setEvents = (type = 'on') => {
  if (!['on', 'off'].includes(type)) return

  Object
    .keys(EVENTS)
    .map(key => {
      const event = EVENTS[key]

      event.callbacks
        .map(callback => {
          Router.events[type](event.name || key, callback)
        })
    })
}

const unmount = () => {
  setEvents('off')
}

const mount = () => {
  unmount()

  if (isProduction) {
    firebaseEvent()
  }

  setEvents('on')

  return unmount
}

export default {
  unmount,
  mount
}
